module.exports = __webpack_public_path__ + "static/2front-about-company-methods-2-036bd952c7f17df546bb136a44dbb0bf.png";